import { getDateFromStringOrDate } from '../../../utils/bill';
import { differenceDatesToString } from '../../../utils';

/**
 * Duration label shown for a `treatment_prescription` row in the prescriptions
 * table (/patient/:uuid/show/submission/:id/prescriptions).
 *
 * A chronic / renewable prescription ("Chronique" / RENOUVELABLE) is saved
 * WITHOUT an end date: the editor (SingleTreatmentSelector) stores no
 * `treatment-finish` key at all, so on read the value is `undefined` — not
 * `null`. The guard therefore has to catch both null and undefined. `!= null`
 * does exactly that; the previous `!== null` let `undefined` slip into the
 * "has end date" branch and called differenceDatesToString(start, undefined),
 * which crashed on `undefined.getTime()` and took the whole page down via the
 * ErrorBoundary. Other date guards in this file already use the undefined-aware
 * form (see index.tsx:307).
 */
export function computePrescriptionDuration(
    start: string | Date | null | undefined,
    finish: string | Date | null | undefined,
    translate: (translationId: string) => string,
): string {
    if (finish != null) {
        const startDate = getDateFromStringOrDate(start);
        const finishDate = getDateFromStringOrDate(finish);
        const objectDifference = differenceDatesToString(startDate, finishDate);

        const timeUnit = Object.keys(objectDifference)[0];
        return objectDifference[timeUnit] + ' ' + translate(`hospital.time-unit-options.${timeUnit}`);
    }
    return translate('hospital.chronic');
}
